import { Form, Input, Row, Col, Switch, Select, DatePicker } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../../utilsTsx/universal/getList';

const EditComponent = (props: any) => {
    const { editMode, defaultService } = props;
    const { membershipId } = props?.sendPageData;
    const apiId = 'membershipBalancePointLock';
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);
    const [membershipData, setMembershipData] = useState<any>();
    const [lockAmountTypeData, setLockAmountTypeData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(defaultService,
            {
                apiId: 'membership',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setMembershipData(res.data);
                }
            })
        fetchApi.GET(defaultService,
            {
                apiId: 'generalData',
                apiVariable: 'membershipLockAmountType',
                apiExtend: 'showLists'
            }).then(res => {
                if (res.success) {
                    const { membershipLockAmountType } = res.data;
                    setLockAmountTypeData(membershipLockAmountType);
                }
            })
    }, []);

    const extendProps: WebEditUniversalProps = {
        ...props,
        apiId,
        displayOptions: {
            width: 600
        },
        dateOptions: {
            columnNames: ['expireDate']
        },
        serviceId: 'business',
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={24}>
                        <Form.Item
                            label="ID"
                            name="id">
                            <Input disabled={true} />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="会员"
                            name="membershipId"
                            initialValue={membershipId} >
                            <Select
                                placeholder="会员"
                                disabled={true}
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }} >
                                {getList.general(membershipData, {
                                    setItemNameFun(item: any) {
                                        return {
                                            id: item.id,
                                            name: `${item.membershipInfo?.membershipName}-${item.membershipType?.typeName}`
                                        }
                                    }
                                })}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="锁定类型"
                            name="lockAmountTypeId">
                            <Select
                                placeholder="锁定类型"
                                showSearch={{
                                    optionFilterProp: 'children',
                                    filterOption: (input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }} >
                                {getList.general(lockAmountTypeData)}
                            </Select>
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="锁定量"
                            name="lockedAmount"
                            initialValue={0}>
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="锁定截止期"
                            name="expireDate"
                            tooltip='锁定截止期'>
                            <DatePicker
                                format="YYYY-MM-DD HH:mm:ss" />
                        </Form.Item>
                    </Col>

                    <Col span={6}>
                        <Form.Item
                            label="状态"
                            name="isUse"
                            valuePropName="checked"
                            initialValue={true}>
                            < Switch checked={true}
                                checkedChildren="启用"
                                unCheckedChildren="关闭" />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };
    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;